/**
 * @description
 * Error page that is presented when the service has an error. 
 * 
 * @author      Brian Sparling
 * @copyright   Mutara Inc. 2019-2023
 */

import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Component({
    selector: 'mutara-error-page',
    template: `<div class='centered'>{{errorMessage}}</div>`,
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {

  errorMessage : string = 'We are experiencing technical difficulties';
  returnUrl : string;
  
  constructor(
    private router : Router
  ) { 
    this.router.events.pipe(
        filter((evt:any) => evt instanceof RoutesRecognized),pairwise())
        .subscribe( (events: RoutesRecognized[]) => {
      this.returnUrl = events[0].urlAfterRedirects ?? '/';
    });
  }

  ngOnInit(): void {
    setTimeout( () => {
      this.router.navigateByUrl( this.returnUrl );
    }, 3000);
  }

}
